import { HttpService as GenericHttpService } from '@bytel/leviator';

import { UserType } from '@app-types/user';

export enum CACHE_TAGS {
    'ALL' = 'cacheAll',
    'PRODUCTS' = 'cacheProducts',
    'PRODUCTS_STOCK' = 'cacheProductsStock',
    'CMS' = 'cacheCms',
    'PRODUCT_DETAIL' = 'cacheProductDetail',
    'FAI' = 'cacheFai',
    'ODR' = 'cacheOdr',
}

export type HttpConfig = {
    headers?: Record<string, string>;
    controller?: AbortController;
    tags?: CACHE_TAGS[];
    ttl?: number;
    user?: UserType;
    timeout?: number;
};

export type HttpService = GenericHttpService<HttpConfig>;
